module.exports = {
      id: "spiritual-usage",
      viewBox: "0 0 27.233 28.49",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#spiritual",
      toString: function () {
        return this.url;
      }
    }